import { LoggerService } from '@wdpr/ra-angular-logger';

import { ConfigService } from '@finder/core/config.service';
import { ScriptLoaderService } from '@finder/shared/services/script-loader/script-loader.service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';
import { CONFIG_CONSTANTS } from '@finder/shared/constants/app.constants';
import { OneIdService } from './one-id.service';

export function OneIdFactory(
    config: ConfigService,
    scriptLoaderService: ScriptLoaderService,
    windowRef: WindowRef,
    logger: LoggerService,
) {
    // Get the scripts from config
    const responderScript = config.getValue(CONFIG_CONSTANTS.oneIdResponderKey);
    const oneIdScript = config.getValue(CONFIG_CONSTANTS.oneIdScriptKey);

    // Use the script loader service to attach the script tags
    const responderScriptLoader = scriptLoaderService.loadScript(responderScript)
        .then((loaded) => logger.debug(`Responder script loaded: ${loaded}`));
    const oneIdScriptLoader = scriptLoaderService.loadScript(oneIdScript)
        .then((loaded) => logger.debug(`OneId script loaded: ${loaded}`));

    return Promise.all([oneIdScriptLoader, responderScriptLoader])
        .then(() => new OneIdService(config, windowRef, logger))
        .catch((err) => {
            const error = new Error(`One of the scripts could not be loaded: ${err}`);
            logger.error(error.message);
            throw error;
        });
}
